import { put, call } from 'redux-saga/effects'
import { delay } from 'redux-saga'
import { startSubmit, stopSubmit, reset } from 'redux-form'
import * as colors from 'material-ui/styles/colors';

import * as commons from '../commons'
import * as ex from '../commons/ex'
import * as actions from '../actions'


export function* handleYosanListInit(action) {

  const {page, form} = action.payload

  yield put(actions.reducerAppLoading(true))

  yield put(actions.reducerYosanSetTransition(false))

  const kenmeiRes = yield call(commons.get2, `/bg/master/kenmei`)
  let check = yield call(errorCheck, kenmeiRes)
  if (!check) {
    return
  }

  const branchOfficeRes = yield call(commons.get2, `/bg/master/branchOffice`)
  check = yield call(errorCheck, branchOfficeRes)
  if (!check) {
    return
  }

  const departmentRes = yield call(commons.get2, `/bg/master/department`)
  check = yield call(errorCheck, departmentRes)
  if (!check) {
    return
  }

  const customerRes = yield call(commons.get2, `/bg/master/customer`)
  check = yield call(errorCheck, customerRes)
  if (!check) {
    return
  }

  const constructionRes = yield call(commons.get2, `/bg/master/construction`)
  check = yield call(errorCheck, constructionRes)
  if (!check) {
    return
  }

  const yosanListRes = yield call(commons.post2, `/bg/yosan/search?page=${page}`, form) 

  const yosanListResCheck = yield call(errorCheck, yosanListRes)
  if (!yosanListResCheck) {
    return
  }

  yield put(actions.reducerYosanListInit(yosanListRes.result, page, form, 
    {
      kenmei: kenmeiRes.result.list,
      branchOffice: branchOfficeRes.result.list,
      department: departmentRes.result.list,
      customer: customerRes.result.list,
      construction: constructionRes.result.list,
    }
  ))

  yield put(actions.reducerYosanStateClear())

  yield call(delay, 100)

  yield put(actions.reducerAppLoading(false))

}


export function* handleYosanHistoryListInit(action) {

  const {page, form} = action.payload

  yield put(actions.reducerAppLoading(true))

  yield put(actions.reducerYosanSetTransition(false))

  const kenmeiRes = yield call(commons.get2, `/bg/master/kenmei`)
  let check = yield call(errorCheck, kenmeiRes)
  if (!check) {
    return
  }

  const branchOfficeRes = yield call(commons.get2, `/bg/master/branchOffice`)
  check = yield call(errorCheck, branchOfficeRes)
  if (!check) {
    return
  }

  const departmentRes = yield call(commons.get2, `/bg/master/department`)
  check = yield call(errorCheck, departmentRes)
  if (!check) {
    return
  }

  const customerRes = yield call(commons.get2, `/bg/master/customer`)
  check = yield call(errorCheck, customerRes)
  if (!check) {
    return
  }

  const constructionRes = yield call(commons.get2, `/bg/master/construction`)
  check = yield call(errorCheck, constructionRes)
  if (!check) {
    return
  }

  const yosanListRes = yield call(commons.post2, `/bg/yosan_history/search?page=${page}`, form)

  const yosanListResCheck = yield call(errorCheck, yosanListRes)
  if (!yosanListResCheck) {
    return
  }

  yield put(actions.reducerYosanHistoryListInit(yosanListRes.result, page, form,
      {
        kenmei: kenmeiRes.result.list,
        branchOffice: branchOfficeRes.result.list,
        department: departmentRes.result.list,
        customer: customerRes.result.list,
        construction: constructionRes.result.list,
      }
  ))

  yield put(actions.reducerYosanStateClear())

  yield call(delay, 100)

  yield put(actions.reducerAppLoading(false))

}

export function* handleYosanListSearch(action) {

  const {page, form, report} = action.payload
  
  yield put(startSubmit(`yosanListForm`))
  yield put(actions.reducerAppLoading(true))

  let startDate;
  if (form.startDate) {
    startDate = form.startDate.format('YYYY-MM-DDT00:00:00.000') + 'Z';
  }

  let endDate;
  if (form.endDate) {
    endDate = form.endDate.format('YYYY-MM-DDT00:00:00.000') + 'Z';
  }

  const newForm = Object.assign({}, form, {startDate, endDate});

  if (report && report == 1) {
    const res = yield call(commons.post2, `/bg/yosan/report`, newForm)

    const check = yield call(errorCheck, res)
    if (!check) {
      return
    }

    yield put(stopSubmit(`yosanListForm`))
    yield put(actions.reducerAppLoading(false))
    return
  }

  const res = yield call(commons.post2, `/bg/yosan/search?page=${page}`, newForm)

  const check = yield call(errorCheck, res)
  if (!check) {
    return
  }


  yield put(stopSubmit(`yosanListForm`))

  if (res.result.count === 0) {
    yield put(actions.reducerSnackBar(true, '検索条件に一致するデータがありません。', colors.blueGrey400))
  }

  yield put(actions.reducerYosanListSetSearchResult(res.result, form, page))

  yield call(delay, 100)
  yield put(actions.reducerAppLoading(false))

}


export function* handleYosanHistoryListSearch(action) {

  const {page, form, report} = action.payload

  yield put(startSubmit(`yosanHistoryListForm`))
  yield put(actions.reducerAppLoading(true))

  if (report && report == 1) {
    const res = yield call(commons.post2, `/bg/yosan/report`, form)

    const check = yield call(errorCheck, res)
    if (!check) {
      return
    }

    yield put(stopSubmit(`yosanHistoryListForm`))
    yield put(actions.reducerAppLoading(false))
    return
  }

  const res = yield call(commons.post2, `/bg/yosan_history/search?page=${page}`, form)

  const check = yield call(errorCheck, res)
  if (!check) {
    return
  }


  yield put(stopSubmit(`yosanHistoryListForm`))

  if (res.result.count === 0) {
    yield put(actions.reducerSnackBar(true, '検索条件に一致するデータがありません。', colors.blueGrey400))
  }

  yield put(actions.reducerYosanHistoryListSetSearchResult(res.result, form, page))

  yield call(delay, 100)
  yield put(actions.reducerAppLoading(false))

}

export function* handleYosanListUpload(action) {

    const {file} = action.payload

    yield put(actions.reducerAppLoading(true))

    const formData = new FormData();
    formData.append('uploadFile', file);

    const res = yield call(ex.upload, `/bg/yosan/upload`, formData)

    const check = yield call(errorCheck, res)
    if (!check) {
        return
    }

    yield put(actions.reducerSnackBar(true, 'アップロードが完了しました。', colors.green400))

    yield put(actions.reducerAppLoading(false))

}


function* errorCheck(res) {

  if (!res) {
    yield put(stopSubmit(`yosanListForm`))
    yield put(actions.reducerSnackBar(true, '通信処理に失敗しました。', colors.red400))
    yield put(actions.reducerAppLoading(false))
    return
  }

  if (res.status && res.status == 401) {
    yield put(actions.reducerSnackBar(true, 'セッションタイムアウト（30分）しました。', colors.red400))
    yield put(stopSubmit(`yosanListForm`))
    yield put(actions.reducerSetAuth({}, 9))
    yield put(actions.reducerAppLoading(false))
    return
  }

  if (res.fetchError || (res.status && res.status != 200)) {
    yield put(stopSubmit(`yosanListForm`))
    yield put(actions.reducerSnackBar(true, '通信処理に失敗しました。', colors.red400))
    yield put(actions.reducerAppLoading(false))
    return false
  }
  
  if (res.error) {
    const {field, message} = res.error
    yield put(stopSubmit(`yosanListForm`, { ...field }))
    yield put(actions.reducerSnackBar(true, message, colors.red400))
    yield put(actions.reducerAppLoading(false))
    return false
  }

  if (res.uploadError) {
      const {detail, message} = res.uploadError
      yield put(actions.reducerErrorMessage(detail.split("@LF@")))
      yield put(actions.reducerSnackBar(true, message, colors.red400))
      yield put(actions.reducerAppLoading(false))
      return false
  }

  return true
}



// WEBPACK FOOTER //
// ./src/sagas/yosanList.js